import React, { useContext } from "react";
import { thousandNumberSeperator } from "../utils/format";
import { ApplicationStatus, GetApplicationStatusAndQuoteResponse } from "../lib-api";


interface QuoteBoxProps {
  StatusAndQuote: GetApplicationStatusAndQuoteResponse
}

const QuoteBox: React.FunctionComponent<QuoteBoxProps> = (props) => {

  if(props.StatusAndQuote.status !== ApplicationStatus.Approved)
  {
    return null;
  }
  const state = props.StatusAndQuote!.quote!;

  const list: [string, string][] = [
    ["Lånebeløb", `${thousandNumberSeperator(state.approvedAmount!)} kr`],
    ["Løbetid", `${state.tenor!.toString()} mdr`],
    ["Ydelse pr. måned", `${thousandNumberSeperator(state.monthlyCost!)} kr`],
    ["Variabel debitorrente", `${thousandNumberSeperator(state.interest!)} %`],
    ["ÅOP", `${thousandNumberSeperator(state.effectiveInterest!)} %`],
    ["Kreditomkostninger", `${thousandNumberSeperator(state.totalFeesAndInterest!)} kr`],
    ["Samlet tilbagebetalingsbeløb", `${thousandNumberSeperator(state.totalRepaymentAmount!)} kr`],
    ["Aftalegebyr", `${thousandNumberSeperator(state.arrangementFee!)} kr`],
    ["Kontogebyr pr. måned", `${thousandNumberSeperator(state.monthlyAccountFee!)} kr`],
    ["Administrationsgebyr", `${thousandNumberSeperator(state.adminFee!)} kr`],
    // ["?Consolidation Demand?", `${thousandNumberSeperator(state.consolidationDemand!)} kr`],
  ];

  return (
    
      <div className="flex flex-col  border-white rounded shadow-md mt-4">

        <div className="flex-initial w-full p-2 bg-white rounded-sm">
          {list.map((item, index) => 
            <div key={index} className="flex w-full py-1 border-b border-gray-200 font-semibold text-regal-darkestblue">
              <div className="flex-initial truncate">{item[0]}</div>
              <div className="flex-grow text-right whitespace-nowrap">
                {item[1]}
              </div>
            </div>
          )}
          
        </div>
      </div>
    
  );
};

export default QuoteBox;
